import { validateTypePanel } from 'FormsUI/utils/FormCreationUtils';
import { hasBusinessUnitsAccess as hasBusinessUnitsAccessFromSelector } from 'FormsUI/selectors/BusinessUnitsAccess';
const root = state => state.formCreation || {};
export const getFormCreationRequestState = state => root(state).requestState;
export const getSelectedType = state => root(state).selectedType;
export const getSelectedBusinessUnitId = state => root(state).selectedBusinessUnit;
export function getTypePanelErrors(state) {
  const businessUnitId = getSelectedBusinessUnitId(state);
  const hasBusinessUnitAccess = hasBusinessUnitsAccessFromSelector(state);
  return validateTypePanel({
    businessUnitId,
    hasBusinessUnitAccess
  });
}